export type MembersImportSchema = 'members' | 'default_columns' | 'full_name_phone';

export type MembersImportStatus = 'validated' | 'queued' | 'running' | 'completed' | 'failed';

export interface MembersImportRowError {
  row: number,
  column: number,
  reason: string,
}

export interface MembersImportNotImported {
  row: number,
  reason: string,
}

export interface MembersImport {
  id: string,
  status: MembersImportStatus,
  statusLabel?: string,
  schema: MembersImportSchema,
  fileName: string,
  totalRows: number,
  validCount: number,
  invalidCount: number,
  canStart: boolean,
  /** Только в ответе validate */
  errors?: MembersImportRowError[],
  /** Поля ниже приходят в ответах start и get */
  createdCount?: number,
  notImportedCount?: number,
  notImported?: MembersImportNotImported[],
  createdAt?: string,
  startedAt?: string | null,
  finishedAt?: string | null,
  progressAt?: string | null,
  error?: string | null,
}

export interface MembersImportResult {
  data?: MembersImport,
  error?: string,
  /** HTTP-статус ошибки: 404 — импорт не найден или удалён, 409 — уже запущен */
  status?: number,
}

export interface MembersImportTemplateResult {
  blob?: Blob,
  error?: string,
  status?: number,
}

/** Подписи колонок шаблона в порядке следования для каждой раскладки */
export const MEMBERS_IMPORT_SCHEMAS: Record<MembersImportSchema, string[]> = {
  members: ['ФИО', 'Дата рождения', 'Город', 'Лейбл', 'Телефон'],
  default_columns: ['Фамилия', 'Имя', 'Дата рождения', 'Телефон', 'Почта', 'Телеграм'],
  full_name_phone: ['ФИО', 'Телефон'],
};

export const MEMBERS_IMPORT_POLL_INTERVAL = 3000;

export const MEMBERS_IMPORT_SETTING_CODE = 'members_import.enabled';

/** Раскладка файла — настройка клуба, в запросе validate её не передаём */
export const MEMBERS_IMPORT_SCHEMA_SETTING_CODE = 'members_import.schema';

export const MEMBERS_IMPORT_DEFAULT_SCHEMA: MembersImportSchema = 'full_name_phone';
